import { Datepicker } from 'vanillajs-datepicker';

const elem = document.querySelector('input[name="foo"]'); 

if (elem !== null) {
  const datepicker = new Datepicker(elem, {
    format: 'MM dd, yyyy',
    orientation: 'bottom auto',
    nextArrow: '>',
    prevArrow: '<',
    minDate: 'Date',
    autohide: 'true',
  }); 
}


